import React from 'react';
import Banner from '../components/landing/LandingBanner';
import Hydrogen from '../components/landing/HydrogenLanding';
import TechLanding from '../components/landing/TechLanding';
import WhoWeAre from '../components/landing/WhoWeAre';
import ResourcesArticlesLanding from '../components/landing/ResourcesArticlesLanding';
import ContactLanding from '../components/landing/ContactLanding';
import GradientText from '../components/landing/GradientText';

const Landing = () => {
  return (
    <div>
      <Banner />
      <Hydrogen />
      <TechLanding />
      <GradientText />
      <WhoWeAre />
      {/* <ResourcesArticlesLanding /> */}
      <ContactLanding /> 
    </div>
  );
};

export default Landing;